import React from "react";
import { data } from "../../Assets/js/data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookSquare,
  faInstagramSquare,
  faYoutubeSquare
} from "@fortawesome/free-brands-svg-icons";

export const About = () => {
  return (
    <div className="about-page">
      <div className="about-content">
        <div className="about-bio">
          <p className="profile-bio">
            Wahyu Mahendranata&nbsp;(
            <a href="https://instagram.com" target="_blank" rel="noreferrer">
              @iw.wm
            </a>
            )&nbsp; is an Indonesian freelance lifestyle and travel photographer
            based in Bali.
            <br />
            <br />
            Wahyu first made a name for himself through his unique creativity
            and ability to capture landscape. His photos concentrate at the
            ambience of the destination and interaction between natural and
            urban atmospheres. Most of his works participate in promoting the
            tourist areas in Bali which consist of small farms, rice fields,
            agroforestry plantations, and tourist accommodation.
            <br />
            <br />
            Wahyu divides his time between between a range of photogenic
            assignments and guiding @baliphotographytour whistlist utilising
            social media as a platform to share his experiences and perspectives
            on life and nature around the world.
          </p>
          <br />
          <b>AWARDS</b>
          <br />
          <p>
            <b>Talented drone/aerial photographers in the world</b>
            <br />
            <i>Featured on Neighbor Korea Magazine Agustus 2017</i>
          </p>
          <p>
            <b>Inspiring Talent</b>
            <br />
            <i>Featured on Grumpy Magazine Paris April-May 2017</i>
          </p>
          <p>
            <b>Selected Photographers Beautiful Destinations</b>
            <br />
            <i>‘Behind The Handle’ Project 2017</i>
          </p>
          <br />
          <b>CLIENTS</b>
          <p>
            Wahyu has worked on assignment with clients such as Omnia Bali, Air
            Asia, Qatar Airways, Singapore Airlines, Starwood Hotels and
            Resorts, Traveloka, Tokopedia, Indonesia Tourism Board, South Tyrol
            Tourism Board - Italy, Graubunden Tourism Board - Switzerland,
            Grindelwald Tourism Board - Switzerland, Malaysia Tourism Board,
            Taiwan Tourism Board, Western Australia Tourism Board, New Zealand
            Tourism Board, Adobe Lightroom, OPPO Smartphone, Sony Alpha
            Indonesia, Starbucks, HP, Unilever.
          </p>
        </div>
        <div className="about-showcase">
          <img className="profile-image" src={data.profile} />
          <iframe
            className="youtube-embed"
            src="https://www.youtube.com/embed/VBPd0TxfDm0"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default About;
